var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml_left"},[_c('temperature'),_c('div',{staticClass:"ma-top"}),_c('waste'),_c('div',{staticClass:"ma-top"}),_c('security'),_c('div',{staticClass:"ma-top"}),_c('gas')],1)}
var staticRenderFns = []

export { render, staticRenderFns }